import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import { AiFillHome } from 'react-icons/ai';
import { FaBoxOpen, FaChartBar, FaCashRegister, FaUniversity, FaCreditCard, FaListAlt, FaPlusCircle, FaClipboardList, FaMoneyBillWave, FaCar, FaBuilding, FaUserFriends, FaTruck, FaExclamationTriangle, FaStickyNote } from 'react-icons/fa';
import { FiSettings, FiChevronDown, FiChevronRight } from 'react-icons/fi';

const Navbar = () => {
  const [openGroups, setOpenGroups] = useState({
    laviago: true,
    spareParts: true
  });

  const toggleGroup = (group) => {
    setOpenGroups(prev => ({
      ...prev,
      [group]: !prev[group]
    }));
  };

  const navGroups = [
    {
      id: 'dashboard',
      items: [
        { to: '/', label: 'Dashboard', icon: <AiFillHome size={20} />, exact: true }
      ]
    },
    {
      id: 'spareParts',
      title: 'Spare Parts',
      icon: <FaBoxOpen size={20} />,
      items: [
        { to: '/products', label: 'Products', icon: <FaBoxOpen size={20} /> },
        { to: '/categories', label: 'Categories', icon: <FaListAlt size={20} /> },
        { to: '/product-order', label: 'New Order', icon: <FaPlusCircle size={20} /> },
        { to: '/order-history', label: 'Order History', icon: <FaClipboardList size={20} /> },
        { to: '/spare-spending', label: 'Record Spending', icon: <FaMoneyBillWave size={20} /> },
        { to: '/sales', label: 'Sales', icon: <FaCashRegister size={20} /> },
        { to: '/credit-register', label: 'Credit Register', icon: <FaCreditCard size={20} /> },
        { to: '/transactions', label: 'Transactions', icon: <FaListAlt size={20} /> },
        { to: '/deposit', label: 'Deposit', icon: <FaUniversity size={20} /> },
        { to: '/low-stock', label: 'Low Stock', icon: <FaExclamationTriangle size={20} /> }
      ]
    },
    {
      id: 'laviago',
      title: 'Laviago',
      icon: <FaCar size={20} />,
      items: [
        { to: '/vehicle-management', label: 'Vehicles', icon: <FaTruck size={20} /> },
        { to: '/carwash-transaction', label: 'Carwash', icon: <FaCar size={20} /> },
        { to: '/carwash-spending', label: 'Carwash Spending', icon: <FaMoneyBillWave size={20} /> },
        { to: '/institutional-spending', label: 'Institutional', icon: <FaBuilding size={20} /> },
        { to: '/workers-credit', label: 'Workers Credit', icon: <FaUserFriends size={20} /> },
        { to: '/carwash-report', label: 'Carwash Report', icon: <FaChartBar size={20} /> }
      ]
    },
    {
      id: 'reports',
      items: [
        { to: '/notes', label: 'Notes', icon: <FaStickyNote size={20} /> },
        { to: '/reports', label: 'Reports', icon: <FaChartBar size={20} /> },
        { to: '/settings', label: 'Settings', icon: <FiSettings size={20} /> }
      ]
    }
  ];

  return (
    <nav className="sidebar">
      <div className="navbar-brand">BETSE CENTERAL ⛐</div>
      <div className="sidebar-links">
        {navGroups.map((group) => (
          <div key={group.id} className="nav-group">
            {group.title ? (
              <div 
                className="nav-group-header"
                onClick={() => toggleGroup(group.id)}
              >
                <span className="nav-group-icon">{group.icon}</span>
                <span className="nav-group-title">{group.title}</span>
                <span className="nav-group-arrow">
                  {openGroups[group.id] ? <FiChevronDown size={16} /> : <FiChevronRight size={16} />}
                </span>
              </div>
            ) : null}
            
            <div className={`nav-group-items ${group.title && !openGroups[group.id] ? 'collapsed' : ''}`}>
              {group.items.map(({ to, label, icon, exact }) => (
                <NavLink
                  key={to}
                  end={exact}
                  to={to}
                  className={({ isActive }) =>
                    `nav-link ${isActive ? 'active' : ''} ${group.title ? 'nested' : ''}`
                  }
                >
                  <span className="icon">{icon}</span>
                  <span className="label">{label}</span>
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
